import Api from "..";

const getCongregacoes = async () => {
  try {
    const response = await Api.get("congregacao/listarCongregacoes");
    return response.data;
  } catch (error) {
    throw new Error(`Erro ao buscar congregações: ${error.message}`);
  }
};

const getCongregacaoById = async (id) => {
  try {
    const response = await Api.get(`/congregacao/buscarCongregacaoPorId?id=${id}`);
    return response.data;
  } catch (error) {
    throw new Error(`Erro ao buscar congregação com ID ${id}: ${error.message}`);
  }
};

export default {
  getCongregacoes,
  getCongregacaoById,
};
